module.exports = __webpack_public_path__ + "img/upcoming-events_world-cup.fe5d7c4c.jpg";